import {useSelector} from 'react-redux';

//selectors
import {nidhiBannerDataSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';

//styles
import * as S from './NIDHIBanner.styles';

const NIDHIBanner = () => {
  const nidhiComplianceData = useSelector(nidhiBannerDataSelector);

  if (!nidhiComplianceData?.length) return null;

  return (
    <S.CardOuterWrapper>
      <S.CardInnerWrapper>
        <S.FeatureList>
          {nidhiComplianceData
            .filter(item => item?.title?.length > 0)
            .map((item, idx) => (
              <S.FeatureListItem key={idx}>
                {item?.logoUrl ? <img className="bannerImg" src={item?.logoUrl} /> : null}
                <p className="descText">{item?.title}</p>
                <p className="rightLine"></p>
              </S.FeatureListItem>
            ))}
        </S.FeatureList>
        <p className="certifiedText">Certified by the Ministry of Tourism</p>
      </S.CardInnerWrapper>
    </S.CardOuterWrapper>
  );
};

export default NIDHIBanner;
